import { useState } from 'react';
import VideoPlayerModal from '../../Common/VideoPlayer';

import lockIcon from "../../../img/lock.svg";
import videoPlayerIcon from '../../../img/videoPlayer.svg';


const ModuleTopic = ({ question, preview, src, setShowLockUpError }) => {
  const [isOpen,setOpen] = useState(false);
  return (
    <div className='flex items-center justify-between py-4 px-3 sm:px-6 sm:py-3 border-[1px] border-b-0 first:rounded-t-[12px] first:border-b-0 last:rounded-b-[12px] last:border-b-[1px] bg-white'>
      <span className='sm:text-[15px] sm:leading-[22px] text-[14px] leading-5 font-gilroy-semibold max-w-[230px] sm:max-w-full'>{question}</span>
      {
        preview ? 
        <div className='flex items-center gap-2 cursor-pointer font-gilroy-semibold' onClick={() => setOpen(true)}>
          <span className='sm:text-[16px] sm:leading-6 text-[14px] leading-5 text-[#4659CA]'>Preview</span>
          <img src={videoPlayerIcon} alt='video player' width={20} height={20}/>
        </div>
         :
        <img src={lockIcon} alt='Lock' height={20} width={20} onClick={() => setShowLockUpError(true)}/>
      }
      { isOpen && (
          <VideoPlayerModal 
            title={question}
            src={src}
            onClose={() => setOpen(false)}
          />
      )}
    </div>
  )
}

export default ModuleTopic;
